function parseRating(container) {
  const ratingEl = container.querySelector('.oke-sr-rating, .oke-sr-score, [class*="oke-sr-rating"]');
  if (!ratingEl) return null;

  const match = ratingEl.textContent.match(/(\d+(?:\.\d+)?)/);
  return match ? parseFloat(match[1]) : null;
}

function parseReviewCount(container) {
  const countEl = container.querySelector('.oke-sr-count, [class*="oke-sr-count"]');
  if (!countEl) return null;

  const match = countEl.textContent.replace(/,/g, '').match(/(\d+)/);
  return match ? parseInt(match[1], 10) : null;
}

function formatReviewText(rating, count) {
  const ratingText = rating.toFixed(1);
  const customerWord = count === 1 ? 'customer' : 'customers';
  return `Rated ${ratingText} by ${count.toLocaleString()} ${customerWord}`;
}

function updateReviewText(section) {
  const textEl = section.querySelector('[data-okendo-review-text]');
  const ratingContainer = section.querySelector('[data-oke-star-rating]');
  if (!textEl || !ratingContainer) return;

  const rating = parseRating(ratingContainer);
  const count = parseReviewCount(ratingContainer);

  if (rating !== null && count !== null) {
    textEl.textContent = formatReviewText(rating, count);
  }
}

function initReviewsBar(section) {
  const ratingContainer = section.querySelector('[data-oke-star-rating]');
  if (!ratingContainer) return;

  const link = section.dataset.reviewsLink;
  if (link) {
    section.style.cursor = 'pointer';
    section.addEventListener('click', () => {
      window.location.href = link;
    });
  }

  updateReviewText(section);

  const observer = new MutationObserver(() => updateReviewText(section));
  observer.observe(ratingContainer, { childList: true, subtree: true, characterData: true });
}

document.querySelectorAll('.okendo-reviews-bar').forEach(initReviewsBar);
